<template>
  <section class="headSection">
    <div class="d-flex bread_flex flex-wrap">
      <v-breadcrumbs divider=">>" :items="items">
        <template v-slot:item="{ item }">
          <router-link :to="item.href" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </router-link>
        </template>
      </v-breadcrumbs>
      <div class="filter_icon frm-action" v-if="search_route">
        <router-link :to="search_route" class="btn w-100">
          <span>
            <i :class="'fas ' + icon"></i>
            {{ search_title }}
          </span>
        </router-link>
      </div>
      <div
        v-if="search_box"
        class="search_breadcrumb_search"
        @click="
          () => {
            $emit('search_open');
          }
        "
      >
        <label for="search_bread_input" class="label"
          ><i class="fas fa-search"></i
        ></label>
        <!-- <input
          id="search_bread_input"
          @input="
            (e) => {
              $emit('searchChange', e.target.value);
            }
          "
          placeholder="بحث برقم الهاتف"
        /> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: [
    "items",
    "title",
    "search_title",
    "search_route",
    "icon",
    "search_box",
  ],
  computed: {
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },
};
</script>

<style lang="scss" scoped>
.frm-action a.btn {
  background: var(--mainColor-2) !important;
  color: #fff !important;
  height: 45px;
  font-size: 16px;
  min-width: 200px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.search_breadcrumb_search {
  border: 1px solid rgba(128, 128, 128, 0.446);
  border-radius: 10px;
  padding: 5px 10px;
  cursor: pointer;
  label {
    color: gray;
  }
}
</style>
